export default {
    "6472611723__et__Original": {
        "filename": "6472611723__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Massivwand": [
                "Massiivsein 180 kg/m²"
            ],
            "Vorwand_Beplankung": [
                "Esimüür"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "Schallschutzset": [
                "Geberit heliisolatsiooni komplekt"
            ],
            "Kombifix Elemente": [
                "Geberit Kombifix valamu",
                "element",
                "Geberit Kombifix seinale",
                "paigaldatava WC element"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-db20": [
                "Geberit Silent-db20 (tuletõkkega)"
            ],
            "Silent-PP": [
                "Geberit Silent-PP"
            ],
            "Silent-Pro": [
                "Geberit Silent-Pro (tuletõkkega)"
            ]
        }
    },
    "6472693003__et__Original": {
        "filename": "6472693003__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Massivwand": [
                "Massiivsein 180 kg/m²"
            ],
            "Vorwand_Beplankung": [
                "Esimüür"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "Schallschutzset": [
                "Geberit heliisolatsiooni komplekt"
            ],
            "Kombifix Elemente": [
                "Geberit Kombifix valamu",
                "element",
                "Geberit Kombifix seinale",
                "paigaldatava WC element"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-PP": [
                "Geberit Silent-PP (tuletõkkega)"
            ]
        }
    },
    "6470917003__et__Original": {
        "filename": "6470917003__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Trockenbauwand": [
                "Kipsvahesein",
                "Tüüp: Firma Knauf, W112, CW75-profiil,",
                "Plaatkate 2 x 12,5 mm,",
                "Isolatsioon mineraalkiudplaatidega 4 cm",
                "(mahumass 24 kg/m³)"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "Duofix Elemente": [
                "Geberit Duofix element",
                "seinaäravooluga dušile",
                "Geberit Duofix eraldusriba",
                "Geberit Duofix valamu element",
                "Geberit Duofix seinale paigaldatava WC element"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-db20": [
                "Geberit Silent-db20 (tuletõkkega)"
            ],
            "Vorwand_Beplankung": [
                "Esisein Geberit Duofix süsteem,",
                "Plaatkate 1 x 18 mm"
            ],
            "Silent-PP": [
                "Geberit Silent-PP"
            ],
            "Silent-Pro": [
                "Geberit Silent-Pro (tuletõkkega)"
            ]
        }
    },
    "6469261707__et__Original": {
        "filename": "6469261707__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Trockenbauwand": [
                "Kipsvahesein",
                "Geberit Duofix süsteem,",
                "Plaatkate 1 x 18 mm,",
                "Isolatsioon kaetud seinapoole",
                "vastas, 5 cm (mahumass 50 kg/m³)"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "Duofix Elemente": [
                "Geberit Duofix element",
                "seinaäravooluga dušile",
                "Geberit Duofix eraldusriba",
                "Geberit Duofix valamu element",
                "Geberit Duofix seinale paigaldatava WC element"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-db20": [
                "Geberit Silent-db20 (tuletõkkega)"
            ],
            "Silent-Pro": [
                "Geberit Silent-Pro (tuletõkkega)"
            ]
        }
    },
    "6471036427__et__Original": {
        "filename": "6471036427__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Massivwand": [
                "Massiivsein 180 kg/m²"
            ],
            "Vorwand_Beplankung": [
                "Esisein Geberit GIS",
                "Plaatkate 1 x 18 mm"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "GIS Elemente": [
                "Geberit GIS element",
                "seinaäravooluga dušile",
                "Geberit GIS eraldusriba",
                "Geberit GIS valamu element",
                "Geberit GIS seinale paigaldatava WC element",
                "Geberit GIS heliisolatsiooniplaat"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-PP": [
                "Geberit Silent-PP (tuletõkkega)"
            ]
        }
    },
    "6472505739__et__Original": {
        "filename": "6472505739__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Trockenbauwand": [
                "Kipsvahesein ",
                "Tüüp: Firma Knauf, W116, ",
                "Plaatkate 2 x 12,5 mm,",
                "Isolatsioon mineraalkiudplaatidega, ",
                "4 cm (mahumass 24 kg/m³)"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "Duofix Elemente": [
                "Geberit Duofix element",
                "seinaäravooluga dušile",
                "Geberit Duofix valamu element",
                "Geberit Duofix seinale paigaldatava WC element"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-db20": [
                "Geberit Silent-db20 (tuletõkkega)"
            ],
            "Silent-Pro": [
                "Geberit Silent-Pro (tuletõkkega)"
            ]
        }
    },
    "6470971659__et__Original": {
        "filename": "6470971659__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Trockenbauwand": [
                "Kipsvahesein ",
                "Geberit Duofix süsteem, ",
                "Plaatkate 1 x 18 mm,",
                "Isolatsioon kaetud ",
                "seinapoole vastas, ",
                "5 cm (mahumass 50 kg/m³)"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "Duofix Elemente": [
                "Geberit Duofix element",
                "seinaäravooluga dušile",
                "Geberit Duofix eraldusriba",
                "Geberit Duofix valamu element",
                "Geberit Duofix seinale paigaldatava WC element"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-db20": [
                "Geberit Silent-db20 (tuletõkkega)"
            ],
            "Silent-PP": [
                "Geberit Silent-PP"
            ],
            "Silent-Pro": [
                "Geberit Silent-Pro (tuletõkkega)"
            ]
        }
    },
    "6467329163__et__Original": {
        "filename": "6467329163__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Trockenbauwand": [
                "Kipsvahesein",
                "Geberit Duofix süsteem (ühekordne karkass),",
                "Plaatkate 1 x 18 mm",
                "Isolatsioon 5 cm (mahumass 50 km/m³)"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "Duofix Elemente": [
                "Geberit Duofix element",
                "seinaäravooluga dušile",
                "Geberit Duofix eraldusriba",
                "Geberit Duofix valamu element",
                "Geberit Duofix seinale paigaldatava WC element"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-db20": [
                "Geberit Silent-db20 (tuletõkkega)"
            ],
            "Vorwand_Beplankung": [
                "Esisein Geberit Duofix süsteem,",
                "Plaatkate 1 x 18 mm"
            ],
            "Silent-Pro": [
                "Geberit Silent-Pro (tuletõkkega)"
            ]
        }
    },
    "6472442763__et__Original": {
        "filename": "6472442763__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Trockenbauwand": [
                "Kipsvahesein ",
                "Tüüp: Firma Knauf, W116, ",
                "Plaatkate 2 x 12,5 mm,",
                "Isolatsioon mineraalkiudplaatidega, ",
                "4 cm (mahumass 24 kg/m³)"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "Duofix Elemente": [
                "Geberit Duofix element",
                "seinaäravooluga dušile",
                "Geberit Duofix valamu element",
                "Geberit Duofix seinale paigaldatava WC element"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-db20": [
                "Geberit Silent-db20 (tuletõkkega)"
            ],
            "Silent-Pro": [
                "Geberit Silent-Pro (tuletõkkega)"
            ]
        }
    },
    "6471082507__et__Original": {
        "filename": "6471082507__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Trockenbauwand": [
                "Kipsvahesein",
                "Tüüp: Firma Knauf, W112, CW75-profiil,",
                "Plaatkate 2 x 12,5 mm,",
                "Isolatsioon mineraalkiudplaatidega 4 cm",
                "(mahumass 24 kg/m³)"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "GIS Elemente": [
                "Geberit GIS element",
                "seinaäravooluga dušile",
                "Geberit GIS eraldusriba",
                "Geberit GIS valamu element",
                "Geberit GIS seinale paigaldatava WC element",
                "Geberit GIS heliisolatsiooniplaat"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-PP": [
                "Geberit Silent-PP (tuletõkkega)"
            ],
            "Vorwand_Beplankung": [
                "Esisein Geberit GIS,",
                "Plaatkate 1 x 18 mm"
            ]
        }
    },
    "6467190795__et__Original": {
        "filename": "6467190795__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Massivwand": [
                "Massiivsein 180 kg/m²"
            ],
            "Vorwand_Beplankung": [
                "Esisein Geberit Duofix süsteem",
                "Plaatkate 1 x 18 mm"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "Duofix Elemente": [
                "Geberit Duofix element",
                "seinaäravooluga dušile",
                "Geberit Duofix eraldusriba",
                "Geberit Duofix valamu element",
                "Geberit Duofix seinale paigaldatava WC element"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-db20": [
                "Geberit Silent-db20 (tuletõkkega)"
            ],
            "Silent-Pro": [
                "Geberit Silent-Pro (tuletõkkega)"
            ]
        }
    },
    "6470844299__et__Original": {
        "filename": "6470844299__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Trockenbauwand": [
                "Vahesein Geberit GIS, ",
                "Plaatkate 1 x 18 mm,",
                "Isolatsioon kaetud",
                "seinapoole vastas, 5 cm (mahumass 50 kg/m³)"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "GIS Elemente": [
                "Geberit GIS element",
                "seinaäravooluga dušile",
                "Geberit GIS eraldusriba",
                "Geberit GIS valamu element",
                "Geberit GIS seinale paigaldatava WC element",
                "Geberit GIS heliisolatsiooniplaat"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-db20": [
                "Geberit Silent-db20 (tuletõkkega)"
            ],
            "Silent-PP": [
                "Geberit Silent-PP"
            ],
            "Silent-Pro": [
                "Geberit Silent-Pro (tuletõkkega)"
            ]
        }
    },
    "6453031691__et__Original": {
        "filename": "6453031691__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Massivwand": [
                "Massiivsein 180 kg/m²"
            ],
            "Vorwand_Beplankung": [
                "Esisein Geberit GIS",
                "Plaatkate 1 x 18 mm"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "GIS Elemente": [
                "Geberit GIS element",
                "seinaäravooluga dušile",
                "Geberit GIS eraldusriba",
                "Geberit GIS valamu element",
                "Geberit GIS seinale paigaldatava WC element",
                "Geberit GIS heliisolatsiooniplaat"
            ],
            "Geberit Mapress": [
                "Geberit Mapress (tuletõkkega)"
            ],
            "Silent-db20": [
                "Geberit Silent-db20 (tuletõkkega)"
            ],
            "Silent-Pro": [
                "Geberit Silent-Pro (tuletõkkega)"
            ],
            "Geberit Mepla": [
                "Geberit Mepla (tuletõkkega)"
            ]
        }
    },
    "6469928971__et__Original": {
        "filename": "6469928971__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Trockenbauwand": [
                "Kipsvahesein",
                "Tüüp: Firma Knauf, W112, CW75-profiil,",
                "Plaatkate 2 x 12,5 mm,",
                "Isolatsioon mineraalkiudplaatidega 4 cm",
                "(mahumass 24 kg/m³)"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "Duofix Elemente": [
                "Geberit Duofix element",
                "seinaäravooluga dušile",
                "Geberit Duofix eraldusriba",
                "Geberit Duofix valamu element",
                "Geberit Duofix seinale paigaldatava WC element"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-db20": [
                "Geberit Silent-db20 (tuletõkkega)"
            ],
            "Vorwand_Beplankung": [
                "Esisein Geberit Duofix süsteem,",
                "Plaatkate 1 x 18 mm"
            ],
            "Silent-Pro": [
                "Geberit Silent-Pro (tuletõkkega)"
            ]
        }
    },
    "6471148171__et__Original": {
        "filename": "6471148171__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Massivwand": [
                "Massiivsein 180 kg/m²"
            ],
            "Vorwand_Beplankung": [
                "Esisein Geberit Duofix süsteem",
                "Plaatkate 1 x 18 mm"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "GIS Elemente": [
                "Geberit Duofix element",
                "seinaäravooluga dušile",
                "Geberit Duofix eraldusriba",
                "Geberit Duofix valamu element",
                "Geberit Duofix seinale paigaldatava WC element"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-PP": [
                "Geberit Silent-PP (tuletõkkega)"
            ]
        }
    },
    "6472530827__et__Original": {
        "filename": "6472530827__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Trockenbauwand": [
                "Kipsvahesein ",
                "Tüüp: Firma Knauf, W116, ",
                "Plaatkate 2 x 12,5 mm,",
                "Isolatsioon mineraalkiudplaatidega, ",
                "4 cm (mahumass 24 kg/m³)"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "Duofix Elemente": [
                "Geberit Duofix element",
                "seinaäravooluga dušile",
                "Geberit Duofix valamu element",
                "Geberit Duofix seinale paigaldatava WC element"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-PP": [
                "Geberit Silent-PP (tuletõkkega)"
            ]
        }
    },
    "6472577931__et__Original": {
        "filename": "6472577931__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Massivwand": [
                "Massiivsein 180 kg/m²"
            ],
            "Vorwand_Beplankung": [
                "Esimüür"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "Schallschutzset": [
                "Geberit heliisolatsiooni komplekt"
            ],
            "Kombifix Elemente": [
                "Geberit Kombifix valamu",
                "element",
                "Geberit Kombifix seinale",
                "paigaldatava WC element"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-db20": [
                "Geberit Silent-db20 (tuletõkkega)"
            ],
            "Silent-Pro": [
                "Geberit Silent-Pro (tuletõkkega)"
            ]
        }
    },
    "6465952907__et__Original": {
        "filename": "6465952907__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Trockenbauwand": [
                "Kipsvahesein",
                "Tüüp: Firma Knauf, W112, CW75-profiil,",
                "Plaatkate 2 x 12,5 mm,",
                "Isolatsioon mineraalkiudplaatidega 4 cm",
                "(mahumass 24 kg/m³)"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "GIS Elemente": [
                "Geberit GIS element",
                "seinaäravooluga dušile",
                "Geberit GIS eraldusriba",
                "Geberit GIS valamu element",
                "Geberit GIS seinale paigaldatava WC element",
                "Geberit GIS heliisolatsiooniplaat"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-db20": [
                "Geberit Silent-db20 (tuletõkkega)"
            ],
            "Vorwand_Beplankung": [
                "Esisein Geberit GIS,",
                "Plaatkate 1 x 18 mm"
            ],
            "Silent-Pro": [
                "Geberit Silent-Pro (tuletõkkega)"
            ]
        }
    },
    "6470756619__et__Original": {
        "filename": "6470756619__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Massivwand": [
                "Massiivsein 180 kg/m²"
            ],
            "Vorwand_Beplankung": [
                "Esisein Geberit GIS",
                "Plaatkate 1 x 18 mm"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "GIS Elemente": [
                "Geberit GIS element",
                "seinaäravooluga dušile",
                "Geberit GIS eraldusriba",
                "Geberit GIS valamu element",
                "Geberit GIS seinale paigaldatava WC element",
                "Geberit GIS heliisolatsiooniplaat"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-db20": [
                "Geberit Silent-db20 (tuletõkkega)"
            ],
            "Silent-PP": [
                "Geberit Silent-PP"
            ],
            "Silent-Pro": [
                "Geberit Silent-Pro (tuletõkkega)"
            ]
        }
    },
    "6470894475__et__Original": {
        "filename": "6470894475__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Massivwand": [
                "Massiivsein 180 kg/m²"
            ],
            "Vorwand_Beplankung": [
                "Esisein Geberit Duofix süsteem",
                "Plaatkate 1 x 18 mm"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "Duofix Elemente": [
                "Geberit Duofix element",
                "seinaäravooluga dušile",
                "Geberit Duofix eraldusriba",
                "Geberit Duofix valamu element",
                "Geberit Duofix seinale paigaldatava WC element"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-db20": [
                "Geberit Silent-db20 (tuletõkkega)"
            ],
            "Silent-PP": [
                "Geberit Silent-PP"
            ],
            "Silent-Pro": [
                "Geberit Silent-Pro (tuletõkkega)"
            ]
        }
    },
    "6471123851__et__Original": {
        "filename": "6471123851__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Trockenbauwand": [
                "Vahesein Geberit GIS, ",
                "Plaatkate 1 x 18 mm,",
                "Isolatsioon kaetud",
                "seinapoole vastas, 5 cm (mahumass 50 kg/m³)"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "GIS Elemente": [
                "Geberit GIS element",
                "seinaäravooluga dušile",
                "Geberit GIS eraldusriba",
                "Geberit GIS valamu element",
                "Geberit GIS seinale paigaldatava WC element",
                "Geberit GIS heliisolatsiooniplaat"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-PP": [
                "Geberit Silent-PP (tuletõkkega)"
            ]
        }
    },
    "6470780299__et__Original": {
        "filename": "6470780299__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Trockenbauwand": [
                "Kipsvahesein",
                "Tüüp: Firma Knauf, W112, CW75-profiil,",
                "Plaatkate 2 x 12,5 mm,",
                "Isolatsioon mineraalkiudplaatidega 4 cm",
                "(mahumass 24 kg/m³)"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "GIS Elemente": [
                "Geberit GIS element",
                "seinaäravooluga dušile",
                "Geberit GIS eraldusriba",
                "Geberit GIS valamu element",
                "Geberit GIS seinale paigaldatava WC element",
                "Geberit GIS heliisolatsiooniplaat"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-db20": [
                "Geberit Silent-db20 (tuletõkkega)"
            ],
            "Vorwand_Beplankung": [
                "Esisein Geberit GIS,",
                "Plaatkate 1 x 18 mm"
            ],
            "Silent-PP": [
                "Geberit Silent-PP"
            ],
            "Silent-Pro": [
                "Geberit Silent-Pro (tuletõkkega)"
            ]
        }
    },
    "6471224459__et__Original": {
        "filename": "6471224459__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Trockenbauwand": [
                "Kipsvahesein",
                "Tüüp: Firma Knauf, W112, CW75-profiil,",
                "Plaatkate 2 x 12,5 mm,",
                "Isolatsioon mineraalkiudplaatidega 4 cm",
                "(mahumass 24 kg/m³)"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "Duofix Elemente": [
                "Geberit Duofix element",
                "seinaäravooluga dušile",
                "Geberit Duofix eraldusriba",
                "Geberit Duofix valamu element",
                "Geberit Duofix seinale paigaldatava WC element"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-PP": [
                "Geberit Silent-PP (tuletõkkega)"
            ],
            "Vorwand_Beplankung": [
                "Esisein Geberit Duofix süsteem,",
                "Plaatkate 1 x 18 mm"
            ]
        }
    },
    "6465931147__et__Original": {
        "filename": "6465931147__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Vorwand_Beplankung": [
                "Vahesein Geberit GIS, ",
                "Plaatkate 1 x 18 mm,",
                "Isolatsioon kaetud",
                "seinapoole vastas, 5 cm (mahumass 50 kg/m³)"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "GIS Elemente": [
                "Geberit GIS element",
                "seinaäravooluga dušile",
                "Geberit GIS eraldusriba",
                "Geberit GIS valamu element",
                "Geberit GIS seinale paigaldatava WC element",
                "Geberit GIS heliisolatsiooniplaat"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-db20": [
                "Geberit Silent-db20 (tuletõkkega)"
            ],
            "Silent-Pro": [
                "Geberit Silent-Pro (tuletõkkega)"
            ]
        }
    },
    "6467012107__et__Original": {
        "filename": "6467012107__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Trockenbauwand": [
                "Kipsvahesein",
                "Geberit Duofix süsteem (ühekordne karkass),",
                "Plaatkate 1 x 18 mm,",
                "Isolatsioon 5 cm (mahumass 50 kg/m³)"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "GIS Elemente": [
                "Geberit GIS element",
                "seinaäravooluga dušile",
                "Geberit GIS eraldusriba",
                "Geberit GIS valamu element",
                "Geberit GIS seinale paigaldatava WC element",
                "Geberit GIS heliisolatsiooniplaat"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-db20": [
                "Geberit Silent-db20 (tuletõkkega)"
            ],
            "Vorwand_Beplankung": [
                "Esisein Geberit GIS,",
                "Plaatkate 1 x 18 mm"
            ],
            "Silent-Pro": [
                "Geberit Silent-Pro (tuletõkkega)"
            ]
        }
    },
    "6471251851__et__Original": {
        "filename": "6471251851__et__Original.jpg",
        "text": {
            "Angrenzender Raum": [
                "Piirnev ruum",
                "(oma piirkonnas)"
            ],
            "Trockenbauwand": [
                "Kipsvahesein ",
                "Geberit Duofix süsteem, ",
                "Plaatkate 1 x 18 mm,",
                "Isolatsioon kaetud ",
                "seinapoole vastas, ",
                "5 cm (mahumass 50 kg/m³)"
            ],
            "Darunterliegender Raum": [
                "Diagonaalselt selle all asuv ruum",
                "(võõras isoleeritavas piirkonnas)"
            ],
            "Duofix Elemente": [
                "Geberit Duofix element",
                "seinaäravooluga dušile",
                "Geberit Duofix eraldusriba",
                "Geberit Duofix valamu element",
                "Geberit Duofix seinale paigaldatava WC element"
            ],
            "Trinkwasserleitung": [
                "Geberit Mapress (koos tuletõkkega)",
                "Geberit Mepla (koos tuletõkkega)"
            ],
            "Silent-PP": [
                "Geberit Silent-PP (tuletõkkega)"
            ]
        }
    }
};